import { Component, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SidebarApi, SidebarComponent } from '../sidebar/sidebar.component';
import {
  SidebarItem,
  SidebarServiceRequest,
  SidebarServiceRequestKind,
} from '../../sidebar.types';
import { SidebarService } from '../../services/sidebar.service';
import { tap } from 'rxjs';
import { MenuService } from '../../services/menu.service';

@Component({
  selector: 'app-nav-sidebar',
  imports: [SidebarComponent],
  templateUrl: './nav-sidebar.component.html',
  styleUrl: './nav-sidebar.component.scss',
})
export class NavSidebarComponent {
  mainSelected?: string;
  secondarySelected?: string;

  items: SidebarItem[] = [];
  private api?: SidebarApi;

  private sidebarService = inject(SidebarService);
  private menuService = inject(MenuService);
  private sidebarRequestListener = this.sidebarService.showRequest$.pipe(
    tap(request => {
      this.handleSidebarRequest(request);
    }),
  );

  constructor() {
    this.sidebarRequestListener.pipe(takeUntilDestroyed()).subscribe();
    this.menuService.sidebarItems$
      .pipe(
        tap(items => {
          this.items = items;
        }),
        takeUntilDestroyed(),
      )
      .subscribe();

    this.menuService.activeMenu$
      .pipe(
        tap(path => {
          this.mainSelected = path[0];
          this.secondarySelected = path[1];
        }),
        takeUntilDestroyed(),
      )
      .subscribe();
  }

  onApi(event: SidebarApi) {
    this.api = event;
  }

  private showSidebar(show: boolean) {
    if (show) {
      this.api?.open();
    } else {
      this.api?.close();
    }
  }

  private toggleSidebar() {
    this.api?.toggle();
  }

  private handleSidebarRequest(request: SidebarServiceRequest) {
    if (request.kind === SidebarServiceRequestKind.show) {
      this.showSidebar(request.show);
    } else if (request.kind === SidebarServiceRequestKind.toggle) {
      this.toggleSidebar();
    }
  }

  onItemClick(event: string, items?: SidebarItem[]) {
    if (!items) {
      this.onItemClick(event, this.items);
      return;
    }
    if (items.length === 0) {
      return;
    }
    for (const item of items) {
      if (item.name === event) {
        item.callback?.();
        this.showSidebar(false);
        return;
      }
      this.onItemClick(event, item.children ?? []);
    }
  }
}
